module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article"
  }, [(_vm.article) ? _c('div', {
    staticClass: "next-gen-article__container"
  }, [_c('div', {
    staticClass: "next-gen-article__title"
  }, [(_vm.article.content_type.id === 7) ? _c('div', {
    staticClass: "next-gen-article__title--icon",
    class: 'type__' + _vm.article.content_type.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "21",
      "height": "21",
      "viewBox": "0 0 21 21"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M22.68,17.019l-7.452-4.53a1.018,1.018,0,0,0-1.511.889v8.807a1.02,1.02,0,0,0,1.511.889L22.68,18.8a1.019,1.019,0,0,0,0-1.779Zm5.6.762a10.5,10.5,0,0,0-10.5-10.5h0a10.5,10.5,0,0,0-10.5,10.5v0a10.5,10.5,0,0,0,10.5,10.5h0a10.5,10.5,0,0,0,10.5-10.5Zm-18.967,0a8.465,8.465,0,0,1,8.462-8.467h0a8.465,8.465,0,0,1,8.467,8.462v0a8.465,8.465,0,0,1-8.462,8.467h0a8.465,8.465,0,0,1-8.467-8.462Z",
      "transform": "translate(-7.281 -7.281)"
    }
  })])]) : (_vm.article.content_type.id === 8) ? _c('div', {
    staticClass: "next-gen-article__title--icon",
    class: 'type__' + _vm.article.content_type.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "15.746",
      "height": "21.004",
      "viewBox": "0 0 15.746 21.004"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M24.417,11.02,20.972,7.579A1.97,1.97,0,0,0,19.582,7H11.219A1.975,1.975,0,0,0,9.25,8.974V26.032A1.969,1.969,0,0,0,11.219,28h11.81A1.97,1.97,0,0,0,25,26.032V12.414A1.982,1.982,0,0,0,24.417,11.02Zm-1.55,1.234h-3.12V9.134ZM11.219,26.032V8.974H17.78v4.264a.982.982,0,0,0,.98.984h4.269v11.81H11.219ZM21.483,20.14c-.511-.492-1.933-.363-2.645-.267a3.551,3.551,0,0,1-1.509-1.9,5.165,5.165,0,0,0,.222-2.3.914.914,0,0,0-1.75-.241,5.915,5.915,0,0,0,.289,2.751,33.027,33.027,0,0,1-1.451,3.051c-.816.422-1.927,1.074-2.091,1.894-.135.647,1.066,2.264,3.12-1.283a20.322,20.322,0,0,1,2.8-.825,5.45,5.45,0,0,0,2.288.7.947.947,0,0,0,.723-1.585h0Zm-8.128,3.19A4.918,4.918,0,0,1,14.6,21.9C13.822,23.136,13.354,23.358,13.354,23.33ZM16.7,15.515c.3,0,.275,1.317.073,1.673a3.433,3.433,0,0,1-.073-1.674Zm-1,5.6a16.12,16.12,0,0,0,1.012-2.242,4.513,4.513,0,0,0,1.235,1.456,13.949,13.949,0,0,0-2.248.786Zm5.4-.205s-.205.247-1.524-.315c1.433-.11,1.671.218,1.524.315Z",
      "transform": "translate(-9.25 -6.996)"
    }
  })])]) : (_vm.article.content_type.id === 9) ? _c('div', {
    staticClass: "next-gen-article__title--icon",
    class: 'type__' + _vm.article.content_type.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "15.75",
      "height": "21",
      "viewBox": "0 0 15.75 21"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M21.063,17.172a.493.493,0,0,0-.495-.492H13.683a.494.494,0,0,0-.492.492V18.32a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492Zm-.5,2.953H13.683a.494.494,0,0,0-.492.492v1.148a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492V20.617A.494.494,0,0,0,20.567,20.125ZM25,12.41a1.959,1.959,0,0,0-.583-1.385L20.975,7.583A1.97,1.97,0,0,0,19.584,7H11.219A1.97,1.97,0,0,0,9.25,8.969V26.032A1.969,1.969,0,0,0,11.219,28H23.032A1.971,1.971,0,0,0,25,26.032ZM19.75,9.129l3.121,3.121H19.75Zm3.282,16.9H11.219V8.969h6.563v4.265a.982.982,0,0,0,.98.985h4.27Z",
      "transform": "translate(-9.25 -7)"
    }
  })])]) : (_vm.article.content_type.id === 10) ? _c('div', {
    staticClass: "next-gen-article__title--icon",
    class: 'type__' + _vm.article.content_type.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "23.627",
      "height": "21",
      "viewBox": "0 0 23.627 21"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M20219.232-8589a.984.984,0,0,1-.98-.984.985.985,0,0,1,.98-.985h2.955l.656-1.971h-7.873a1.969,1.969,0,0,1-1.971-1.966v-13.128a1.969,1.969,0,0,1,1.971-1.966h19.686a1.969,1.969,0,0,1,1.971,1.966v13.128a1.976,1.976,0,0,1-1.971,1.971h-7.877l.66,1.966h2.951a.982.982,0,0,1,.949.949.986.986,0,0,1-.949,1.021Zm-3.605-6.566H20234v-11.813h-18.375Zm3.209-2.479a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h7a.58.58,0,0,1,.58.584v1.163a.58.58,0,0,1-.58.584Zm0-4.667a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h10.5a.584.584,0,0,1,.584.584v1.163a.584.584,0,0,1-.584.584Z",
      "transform": "translate(-20213 8609.998)"
    }
  })])]) : (_vm.article.content_type.id === 11) ? _c('div', {
    staticClass: "next-gen-article__title--icon",
    class: 'type__' + _vm.article.content_type.id
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18.53",
      "height": "22.876",
      "viewBox": "0 0 18.53 22.876"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-8 -6.124)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M18.744,14.421H11.87a.493.493,0,0,0-.492.492v1.147a.493.493,0,0,0,.492.492h6.425a5.959,5.959,0,0,1,.886-.275.486.486,0,0,0,.056-.217l0-1.147a.493.493,0,0,0-.5-.492Z",
      "transform": "translate(0.517 1.307)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M11.378,17.866v1.147a.493.493,0,0,0,.492.492h3a6.083,6.083,0,0,1,1.4-2.13h-4.4A.493.493,0,0,0,11.378,17.866Z",
      "transform": "translate(0.526 1.772)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M9.967,25.007V8.078h6.554V12.31a.978.978,0,0,0,.979.977h4.264v4.19a6.065,6.065,0,0,1,1.966.552V11.491a1.937,1.937,0,0,0-.583-1.374L19.71,6.7a1.974,1.974,0,0,0-1.389-.579H9.967A1.961,1.961,0,0,0,8,8.078V25.007A1.961,1.961,0,0,0,9.967,26.96h6.152a5.993,5.993,0,0,1-.9-1.953Zm8.52-16.77,3.117,3.1H18.486Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M25.194,25.933l-1.815-1.815a.44.44,0,0,0-.31-.127h-.3a3.787,3.787,0,0,0-2.983-6.117h0A3.786,3.786,0,0,0,16,21.658v0a3.786,3.786,0,0,0,3.784,3.787h0a3.763,3.763,0,0,0,2.33-.8v.3a.44.44,0,0,0,.127.31l1.815,1.814a.437.437,0,0,0,.615,0l0,0,.515-.516A.441.441,0,0,0,25.194,25.933Zm-5.407-1.942a2.33,2.33,0,1,1,2.33-2.33A2.33,2.33,0,0,1,19.787,23.991Z",
      "transform": "translate(1.21 1.803)"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.article.title))])]), _vm._v(" "), _c('div', {
    staticClass: "next-gen-article__sections"
  }, [_c('div', {
    staticClass: "next-gen-article__section next-gen-article__content",
    attrs: {
      "role": "main"
    }
  }, [((_vm.player.shown && _vm.player.url) || (_vm.imageFullPath !== '' && !_vm.player.shown)) ? _c('div', {
    staticClass: "task-content-media"
  }, [(_vm.player.shown && _vm.player.url) ? _c('div', {
    staticClass: "task-content-video"
  }, [_c('iframe', {
    attrs: {
      "id": "player",
      "frameborder": "0",
      "webkitAllowFullScreen": "",
      "mozallowfullscreen": "",
      "allowFullScreen": "",
      "height": "340",
      "width": "600",
      "src": _vm.player.url
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.imageFullPath !== '' && !_vm.player.shown) ? _c('div', {
    staticClass: "task-content-image",
    class: {
      'video-type': _vm.player.url
    },
    style: ({
      backgroundImage: 'url(' + _vm.imageFullPath + ')'
    }),
    attrs: {
      "title": _vm.article.alt
    }
  }, [(_vm.player.url) ? _c('div', {
    staticClass: "task-content-video-play",
    on: {
      "click": function($event) {
        return _vm.playVideo()
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-play-circle fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "far",
      "data-icon": "play-circle",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1\n                16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200\n                200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
    }
  })])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.article.content_type.id === 8 || _vm.article.content_type.id === 9) ? _c('div', {
    staticClass: "task-content-resources"
  }, [_c('div', {
    staticClass: "task-content-resources-items"
  }, _vm._l((_vm.article.resources), function(resource) {
    return (resource.file) ? _c('a', {
      attrs: {
        "href": "#",
        "role": "button",
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadFile(resource)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-arrow-circle-down fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "arrow-circle-down",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288\n             302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4\n             9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(resource.name ? resource.name : resource.file))])]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-content-text",
    domProps: {
      "innerHTML": _vm.article.content
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "task-content-meta"
  }, [(_vm.article.categories && _vm.article.categories.length) ? _c('div', [_c('i', {
    staticClass: "fas fa-binoculars"
  }), _vm._v(" "), _c('div', [_vm._l((_vm.article.categories), function(category, index) {
    return [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'knowledge-base',
          query: {
            categories: category.id
          }
        }
      }
    }, [_vm._v(_vm._s(category.title))])]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.article.tags && _vm.article.tags.length) ? _c('div', [_c('i', {
    staticClass: "fas fa-tag"
  }), _vm._v(" "), _c('div', [_vm._l((_vm.article.tags), function(tag, index) {
    return [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'knowledge-base',
          query: {
            topics: tag.id
          }
        }
      }
    }, [_vm._v(_vm._s(tag.name))])]
  })], 2)]) : _vm._e()]), _vm._v(" "), (_vm.relatedArticles && _vm.relatedArticles.length) ? _c('div', {
    staticClass: "task-content-related"
  }, [_c('div', {
    staticClass: "task-content-related-header"
  }, [_vm._v("\n            Related resources\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "task-content-related-list"
  }, _vm._l((_vm.relatedArticles), function(item) {
    return _c('li', {
      staticClass: "task-content-related-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          'name': 'content',
          'params': {
            'id': item.id
          }
        }
      }
    }, [(item.content_type) ? _c('div', {
      staticClass: "task-content-related-icon"
    }, [(item.content_type.id === 7) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "play",
        "d": "M20.068,15.367l-6.188-3.762c-0.408-0.226-0.922-0.079-1.149,0.329\n                            c-0.069,0.125-0.106,0.266-0.106,0.409v7.313c0.001,0.467,0.381,0.845,0.849,0.843c0.142,0,0.282-0.037,0.406-0.105l6.188-3.55\n                            c0.408-0.228,0.554-0.743,0.326-1.151C20.317,15.556,20.205,15.443,20.068,15.367z M24.719,16c0.001-4.814-3.901-8.718-8.715-8.719\n                            c-0.001,0-0.003,0-0.004,0c-4.814-0.001-8.718,3.901-8.719,8.715c0,0.001,0,0.003,0,0.004c-0.001,4.814,3.901,8.718,8.715,8.719\n                            c0.001,0,0.003,0,0.004,0c4.814,0.001,8.718-3.901,8.719-8.715C24.719,16.003,24.719,16.001,24.719,16z M8.969,16\n                            c-0.001-3.882,3.145-7.03,7.027-7.031c0.001,0,0.003,0,0.004,0c3.882-0.001,7.03,3.145,7.031,7.027c0,0.001,0,0.003,0,0.004\n                            c0.001,3.882-3.145,7.03-7.027,7.031c-0.001,0-0.003,0-0.004,0c-3.882,0.001-7.03-3.145-7.031-7.027\n                            C8.969,16.003,8.969,16.001,8.969,16z"
      }
    })])])] : (item.content_type.id === 8) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "file-pdf",
        "d": "M22.254,10.446L19.3,7.496c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17\n                              c-0.934,0.003-1.69,0.762-1.688,1.696v14.625c0.001,0.932,0.756,1.687,1.688,1.687h10.125c0.931-0.001,1.686-0.756,1.687-1.687\n                              V11.641C22.749,11.193,22.57,10.763,22.254,10.446z M20.925,11.504H18.25V8.829L20.925,11.504z M10.938,23.317V8.692h5.625v3.656\n                              c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v10.125H10.938z M19.738,18.265\n                              c-0.438-0.422-1.657-0.311-2.268-0.229c-0.609-0.374-1.067-0.95-1.294-1.628c0.211-0.634,0.276-1.307,0.19-1.969\n                              c-0.054-0.43-0.446-0.734-0.876-0.68c-0.277,0.035-0.515,0.215-0.624,0.473c-0.105,0.795-0.02,1.603,0.248,2.359\n                              c-0.37,0.893-0.785,1.766-1.244,2.616c-0.7,0.362-1.652,0.921-1.793,1.624c-0.116,0.555,0.914,1.941,2.675-1.1\n                              c0.782-0.293,1.584-0.529,2.4-0.707c0.602,0.343,1.272,0.548,1.962,0.6c0.448,0.011,0.821-0.343,0.832-0.792\n                              c0.005-0.209-0.071-0.413-0.212-0.567H19.738z M12.769,21c0.273-0.476,0.636-0.893,1.069-1.23\n                              C13.17,20.834,12.769,21.024,12.769,21z M15.638,14.3c0.26,0,0.236,1.129,0.063,1.434c-0.139-0.466-0.161-0.959-0.063-1.435V14.3z\n                               M14.78,19.1c0.338-0.618,0.628-1.26,0.868-1.922c0.26,0.487,0.621,0.912,1.059,1.248C16.047,18.595,15.402,18.821,14.78,19.1\n                              L14.78,19.1z M19.407,18.924c0,0-0.176,0.212-1.307-0.27C19.329,18.56,19.533,18.841,19.407,18.924L19.407,18.924z"
      }
    })])])] : (item.content_type.id === 9) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "id": "file-alt",
        "d": "M19.375,15.719c-0.001-0.234-0.19-0.423-0.424-0.422H18.95h-5.9\n                              c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9c0.233-0.001,0.421-0.189,0.422-0.422\n                              L19.375,15.719z M18.95,18.25h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9\n                              c0.233-0.001,0.421-0.189,0.422-0.422v-0.984C19.371,18.439,19.183,18.251,18.95,18.25z M22.75,11.637\n                              c-0.002-0.446-0.182-0.873-0.5-1.187L19.3,7.5c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17C10.006,7,9.25,7.756,9.25,8.688v14.625\n                              C9.251,24.245,10.006,25,10.938,25h10.125c0.931-0.001,1.686-0.756,1.687-1.687V11.637z M18.25,8.825l2.675,2.675H18.25V8.825z\n                               M21.063,23.313H10.938V8.688h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656V23.313z"
      }
    })])])] : (item.content_type.id === 10) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('g', [_c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M24.438,7H7.563C6.631,7,5.875,7.756,5.875,8.688v11.25c0.001,0.932,0.756,1.687,1.688,1.687h6.75\n                              l-0.563,1.688h-2.531c-0.466,0-0.844,0.378-0.844,0.844S10.753,25,11.219,25h9.563c0.466-0.016,0.831-0.407,0.814-0.872\n                              c-0.015-0.443-0.371-0.799-0.814-0.814H18.25l-0.562-1.687h6.75c0.932-0.001,1.688-0.757,1.687-1.689V8.688\n                              C26.125,7.756,25.37,7.001,24.438,7z M23.875,19.375H8.125V9.25h15.75V19.375z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M10.875,13.25h9c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-9c-0.276,0-0.5,0.224-0.5,0.5v1\n                              C10.375,13.026,10.599,13.25,10.875,13.25z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M10.875,17.25h6c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-6c-0.276,0-0.5,0.224-0.5,0.5v1\n                              C10.375,17.025,10.599,17.25,10.875,17.25z"
      }
    })])])])] : (item.content_type.id === 11) ? [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 32 32"
      },
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 32 32",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('circle', {
      staticClass: "st0",
      attrs: {
        "cx": "16",
        "cy": "16",
        "r": "16"
      }
    }), _vm._v(" "), _c('g', [_c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M17.7,14.421h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.514\n                              c0.245-0.097,0.498-0.177,0.76-0.236c0.028-0.057,0.048-0.118,0.048-0.186l0.003-0.984C18.124,14.609,17.935,14.42,17.7,14.421\n                              C17.701,14.421,17.7,14.421,17.7,14.421z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M11.378,17.796v0.984c0.001,0.233,0.189,0.421,0.422,0.422h2.571c0.272-0.693,0.68-1.316,1.203-1.828H11.8\n                              C11.567,17.375,11.379,17.563,11.378,17.796z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M9.688,22.437V7.812h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v3.62\n                              c0.599,0.067,1.166,0.225,1.687,0.477v-5.648c-0.002-0.446-0.182-0.873-0.5-1.187l-2.95-2.95c-0.315-0.318-0.744-0.498-1.192-0.5\n                              h-7.17C8.756,6.124,8,6.88,8,7.812v14.625c0.001,0.932,0.756,1.687,1.688,1.687h5.28c-0.356-0.503-0.615-1.074-0.776-1.687H9.688z\n                               M17,7.949l2.675,2.675H17V7.949z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "st1",
      attrs: {
        "d": "M23.891,24.791l-1.558-1.558c-0.071-0.07-0.166-0.109-0.266-0.109h-0.254c0.447-0.571,0.689-1.275,0.688-2\n                              c0.001-1.794-1.454-3.249-3.248-3.25c-0.001,0-0.002,0-0.003,0c-1.794-0.001-3.249,1.454-3.25,3.248c0,0.001,0,0.001,0,0.002\n                              c-0.001,1.794,1.454,3.249,3.248,3.25c0.001,0,0.001,0,0.002,0c0.725,0.002,1.429-0.24,2-0.687v0.255\n                              c0,0.1,0.039,0.195,0.109,0.266l1.558,1.557c0.145,0.146,0.381,0.147,0.528,0.003c0.001-0.001,0.002-0.002,0.003-0.003\n                              l0.442-0.443C24.035,25.176,24.036,24.939,23.891,24.791z M19.25,23.124c-1.105,0-2-0.895-2-2s0.895-2,2-2s2,0.895,2,2\n                              S20.355,23.124,19.25,23.124z"
      }
    })])])])] : _vm._e()], 2) : _vm._e(), _vm._v("\n                " + _vm._s(item.title) + "\n              ")])], 1)
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "next-gen-article__side",
    class: {
      'equal-sections': _vm.isRegularUser
    },
    attrs: {
      "role": "complementary"
    }
  }, [(_vm.isLightUser || _vm.isAdmin) ? [(_vm.articleCategories) ? _c('div', {
    staticClass: "next-gen-article__section next-gen-article__categories"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "next-gen-article__categories--items"
  }, _vm._l((_vm.articleCategories), function(category) {
    return _c('li', {
      key: category.id
    }, [_c('router-link', {
      staticClass: "next-gen-article__categories--item",
      attrs: {
        "to": {
          name: 'knowledge-base',
          query: {
            categories: category.id
          }
        }
      }
    }, [(category.icon) ? _c('div', {
      staticClass: "next-gen-article__categories--item__icon",
      domProps: {
        "innerHTML": _vm._s(category.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(category.title))])])], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.articleTopics) ? _c('div', {
    staticClass: "next-gen-article__section next-gen-article__topics"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "next-gen-article__topics--items"
  }, _vm._l((_vm.articleTopics), function(topic) {
    return _c('router-link', {
      key: topic.id,
      staticClass: "next-gen-article__topics--item",
      attrs: {
        "to": {
          name: 'knowledge-base',
          query: {
            topics: topic.id
          }
        }
      }
    }, [(topic.icon) ? _c('div', {
      staticClass: "next-gen-article__topics--item__icon",
      domProps: {
        "innerHTML": _vm._s(topic.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(topic.title))])])
  }), 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isRegularUser) ? [(_vm.relatedTasks && _vm.relatedTasks.length) ? _c('div', {
    staticClass: "next-gen-article__section next-gen-article__tasks"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "next-gen-article__tasks--items"
  }, _vm._l((_vm.relatedTasks), function(task) {
    return _c('router-link', {
      key: task.id,
      staticClass: "next-gen-article__tasks--item",
      attrs: {
        "to": {
          name: 'task',
          params: {
            id: task.id
          }
        },
        "aria-label": task.title
      }
    }, [_c('div', {
      staticClass: "next-gen-article__tasks--item-data"
    }, [_c('span', {
      staticClass: "next-gen-article__tasks--item-key",
      class: {
        'line-through': task.status && task.status.id === 4
      }
    }, [_vm._v("\n                    " + _vm._s(task.key) + "\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "next-gen-article__tasks--item-name"
    }, [_vm._v("\n                    " + _vm._s(task.title) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-article__tasks--item-meta"
    }, [_c('div', {
      staticClass: "next-gen-article__tasks--item-chapter",
      class: {
        empty: !task.chapter
      }
    }, [(task.chapter) ? [_c('div', {
      staticClass: "next-gen-article__tasks--item-chapter-progress"
    }, [_c('div', {
      staticClass: "next-gen-article__tasks--item-chapter-image",
      style: ({
        backgroundImage: _vm.getChapterBackground(task.chapter)
      })
    }), _vm._v(" "), _c('svg', {
      staticClass: "progress",
      attrs: {
        "width": "130",
        "height": "130",
        "viewBox": "0 0 100 100"
      }
    }, [_c('circle', {
      staticClass: "progress_meter",
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }), _vm._v(" "), _c('circle', {
      staticClass: "progress_value",
      class: 'filters_progress_value-' + task.chapter.id,
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-article__tasks--item-chapter-name"
    }, [_vm._v(_vm._s(task.chapter.name))])] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-user-info"
    }, [_c('div', {
      staticClass: "next-gen-article__tasks--item-meta-properties"
    }, [(task.recurrent) ? _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-property recurrency"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-sync-alt fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "sync-alt",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328\n                          53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933\n                          94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504\n                          57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382\n                          0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144\n                          162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187\n                          504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
      }
    })])]) : _vm._e(), _vm._v(" "), (task.mandatory) ? _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-property mandatory"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-exclamation-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "exclamation-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248\n                          111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418\n                          136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884\n                          0-12.356 5.78-11.981 12.654z"
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-user priority",
      class: ['priority-' + _vm.taskPriorityDelta(task.score)]
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-arrow-up fa-w-14",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "arrow-up",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6\n                                              0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.taskPriorityLabelByValue(_vm.taskPriorityDelta(task.score))))])]), _vm._v(" "), (task.status) ? _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-user status",
      class: ['status-' + task.status.id]
    }, [(task.status.id === 1) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                              0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                              168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (task.status.id === 2) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                              368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                              48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                              48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                              0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                              21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (task.status.id === 3) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                              55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                              241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                              0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (task.status.id === 4) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                              256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                              89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                              303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                              16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "status-text"
    }, [_vm._v(_vm._s(task.status.name))])], 2) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "next-gen-article__tasks--item-meta-user user-avatar"
    }, [(task.assignee) ? [(task.assignee.image) ? _c('span', {
      style: ({
        backgroundImage: 'url(\'' + _vm.imageBase + task.assignee.image + '\')'
      })
    }) : _c('avatar', {
      attrs: {
        "username": task.assignee.name,
        "size": 32,
        "color": "#ffffff"
      }
    })] : [_c('svg', {
      staticClass: "svg-inline--fa fa-user-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "user-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 496 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                              88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                              55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                              7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
      }
    })])]], 2)])])])
  }), 1)]) : _vm._e()] : _vm._e()], 2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article__section--title"
  }, [_c('i', {
    staticClass: "fas fa-sitemap"
  }), _vm._v(" "), _c('h2', [_vm._v("Categories")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article__section--title"
  }, [_c('i', {
    staticClass: "fas fa-tag"
  }), _vm._v(" "), _c('h2', [_vm._v("Topics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-article__section--title"
  }, [_c('i', {
    staticClass: "fas fa-link"
  }), _vm._v(" "), _c('h2', [_vm._v("Related tasks")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-295c05a9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/NextGenArticle.vue
// module id = 959
// module chunks = 0